module.exports = __webpack_public_path__ + "static/rocket-7488c9b6cbfc27cbe7f59ae875cfee71.png";